import DOMPurify from 'dompurify';
import { marked } from 'marked';

export const convertMarkdownToHTML = (markdownText) => {
    // マークダウン記法のテキストをHTMLの文字列に変換.
    const markedText = marked(markdownText);

    // DOMPurifyでサニタイズする時のオプションを定義.
    const config = {
        // 許可する属性.
        ALLOWED_ATTR: [
            'href',
            'target',
            'rel',
        ],
        // 許可するタグ.
        ALLOWED_TAGS: [
            'p',
            'br',
            'ul',
            'ol',
            'li',
            'blockquote',
            'strong',
            'em',
            'a',
            'hr',
            'del',
            'pre',
            'code',
        ],
    };
    const htmlText = DOMPurify.sanitize(markedText, config);
    return { __html: htmlText };
};